<template>
  <div v-if="loading" data-search-exempt class="tw-flex tw-flex-wrap tw-gap-4">
    <div
      v-for="n in expectedCount"
      :key="n"
      class="
        tw-grow
        tw-basis-[calc(33.333%-0.667rem)]
        tw-min-w-0
        tw-flex
        tw-flex-col
        tw-gap-4
        tw-bg-white
        tw-rounded-lg
        tw-p-6
        tw-shadow-sm
      "
      data-testid="pinned-report-card-skeleton"
    >
      <SfSkeletonLoader height="1.5rem" width="50%" />
      <SfSkeletonLoader :height="PINNED_CHART_HEIGHT_DEFAULT" width="100%" />
    </div>
  </div>
  <div
    v-else-if="errored"
    data-search-exempt
    class="
      tw-flex
      tw-flex-col
      tw-items-center
      tw-justify-center
      tw-gap-3
      tw-py-10
      tw-bg-white
      tw-rounded-lg
      tw-shadow-sm
      tw-text-sf-neutral-light-1
    "
    data-testid="pinned-reports-error"
  >
    <span>{{ I18n.t('report.drawer.pin_to_top.load_error') }}</span>
    <SfButtonDs @click="emit('retry')">
      {{ I18n.t('report.drawer.pin_to_top.load_error_retry') }}
    </SfButtonDs>
  </div>
  <div v-else class="tw-flex tw-flex-wrap tw-gap-4">
    <PinnedReportCard
      v-for="report in reports"
      :key="report.reportTemplateId"
      class="tw-grow tw-basis-[calc(33.333%-0.667rem)] tw-min-w-0"
      :data-report-name="report.name"
      :report-template-id="report.reportTemplateId"
      :name="report.name"
      :locale="report.locale"
      :path="report.path"
      :pinned="report.pinned"
      :highlighted="report.highlighted"
      :statement="report.statement"
    />
  </div>
</template>

<script setup lang="ts">
import PinnedReportCard from '@app/application/report/components/pinned-report-card.vue'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import SfSkeletonLoader from '@app/shared/vue/components/sf-skeleton-loader.vue'
import { PINNED_CHART_HEIGHT_DEFAULT } from '@app/application/report/constants'
import type { PinnedReport } from '@app/application/report/types'
import useI18n from '@app/shared/vue/composables/use-I18n'

defineOptions({ name: 'PinnedReportCardList' })

defineProps<{
  reports: PinnedReport[]
  loading: boolean
  errored: boolean
  // How many cards the server expects, so the skeletons hold the right
  // amount of space while the fetch runs.
  expectedCount: number
}>()

const emit = defineEmits<{ retry: [] }>()

const I18n = useI18n()
</script>
